import styled from 'styled-components';
import { getBaseTheme } from '@Themes';

const { colors } = getBaseTheme();

const DropDownIconButtonWrapper = styled.div`
    div div span:first-of-type span {
        display: none;
    }

    div[class*='SelectTrigger'] {
        padding: 0;
        width: 2.8rem;
        margin-right: 0.2rem;
        border-radius: 2px 0 0 2px;
        background: white;
        border-color: ${colors.control.focus.complementaryForegroundColor};

        :focus {
            outline: none;
        }

        i {
            right: 22px;
            line-height: 30px;
            cursor: pointer;
            color: ${colors.control.focus.complementaryForegroundColor};

            svg {
                width: 1.6rem;
                height: 1.6rem;
            }
        }
    }

    div[class*='SelectOverlay'] {
        left: 0;
    }
`;

export default DropDownIconButtonWrapper;
